"use strict";

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var underscore_1 = require("underscore");

var BaseProperty_1 = __importDefault(require("./BaseProperty"));

var PropertyModelSpec_1 = require("./PropertyModelSpec");

var MeasureDataItem_1 = __importDefault(require("./MeasureDataItem"));

var RuleConstants_1 = require("../../definitions/constants/RuleConstants");

var ConditionalFormatSpecHelper_1 = require("./util/ConditionalFormatSpecHelper");

var ConditionalFormatSpec =
/** @class */
function (_super) {
  __extends(ConditionalFormatSpec, _super);

  function ConditionalFormatSpec(spec, visType) {
    var _a, _b;

    if (spec === void 0) {
      spec = {};
    }

    var _this = _super.call(this) || this;

    (_a = _this._blackListedAttr).push.apply(_a, ConditionalFormatSpec._ignoreAttr);

    if (ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.isKpiVis(visType)) {
      _this._blackListedAttr.push('backgroundOpacity');
    }

    _this._visType = visType;
    _this.dataItemId = spec['dataItemId'];
    _this.paletteId = spec['paletteId'];
    _this.colorBy = spec['colorBy'];
    _this.scale = spec['scale'];
    _this.rules = new Array();

    (_b = _this.rules).push.apply(_b, spec['rules']);

    var value = spec['backgroundOpacity'];

    if (typeof value === 'number') {
      _this.backgroundOpacity = value;
    } else if (typeof value === 'string') {
      _this.backgroundOpacity = parseInt(value, 10);
    }

    _this.heatId = spec['heatId'];
    _this._active = true;
    return _this;
  }

  ConditionalFormatSpec.prototype.getDataItemId = function () {
    return this.dataItemId;
  };

  ConditionalFormatSpec.prototype.setDataItemId = function (value) {
    this.dataItemId = value;
  };

  ConditionalFormatSpec.prototype.getPaletteId = function () {
    return this.paletteId;
  };

  ConditionalFormatSpec.prototype.setPaletteId = function (value) {
    this.paletteId = value;
  };

  ConditionalFormatSpec.prototype.getColorBy = function () {
    return this.colorBy;
  };

  ConditionalFormatSpec.prototype.setColorBy = function (value) {
    this.colorBy = value;
  };

  ConditionalFormatSpec.prototype.getBackgroundOpacity = function () {
    return this.backgroundOpacity;
  };

  ConditionalFormatSpec.prototype.setBackgroundOpacity = function (value) {
    this.backgroundOpacity = value;
  };

  ConditionalFormatSpec.prototype.getScale = function () {
    return this.scale;
  };

  ConditionalFormatSpec.prototype.setScale = function (value) {
    this.scale = value;
  };

  ConditionalFormatSpec.prototype.getRules = function () {
    return this.rules;
  };

  ConditionalFormatSpec.prototype.setRules = function (rules) {
    var _this = this;

    if (rules === void 0) {
      rules = [];
    }

    this.rules.length = 0;
    rules.forEach(function (rule) {
      var ruleToAdd = rule instanceof PropertyModelSpec_1.Rule ? rule : ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.createNewRule(rule, _this._visType);

      _this._setDefaultRuleConditionValues(ruleToAdd);

      _this.rules.push(ruleToAdd);
    });
  };

  ConditionalFormatSpec.prototype.getRule = function (ruleIdx) {
    return ruleIdx < this.rules.length ? this.rules[ruleIdx] : null;
  };

  ConditionalFormatSpec.prototype.addRule = function (ruleIdx, ruleTypeToAdd) {
    ruleIdx = this.isValidRuleIndex(ruleIdx) ? ruleIdx : this.rules.length;
    var newRule = ruleTypeToAdd instanceof PropertyModelSpec_1.Rule ? ruleTypeToAdd : null;

    if (!newRule) {
      var ruleSpec = underscore_1.isObject(ruleTypeToAdd) ? ruleTypeToAdd : ruleTypeToAdd === RuleConstants_1.RULE_TYPES.THRESHOLD ? ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.getDefaultRuleThreshold(this._visType) : ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.getDefaultRuleRange(this._visType);
      newRule = ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.createNewRule(ruleSpec, this._visType);
    }

    this._setDefaultRuleConditionValues(newRule);

    this.rules.splice(ruleIdx, 0, newRule);
    return newRule;
  };

  ConditionalFormatSpec.prototype.deleteRule = function (ruleIdx) {
    if (this.isValidRuleIndex(ruleIdx)) {
      this.rules.splice(ruleIdx, 1);
      return true;
    }

    return false;
  };

  ConditionalFormatSpec.prototype.moveRule = function (fromIndex, toIndex) {
    if (this.isValidRuleIndex(fromIndex) && this.isValidRuleIndex(toIndex)) {
      this.rules.splice(toIndex, 0, this.rules.splice(fromIndex, 1)[0]);
      return true;
    }

    return false;
  };

  ConditionalFormatSpec.prototype.getNumberOfRules = function () {
    return this.rules.length;
  };

  ConditionalFormatSpec.prototype.getRangeOperator = function (ruleIdx) {
    var rule = this.getRule(ruleIdx);
    return rule ? rule.getOperator() : null;
  };

  ConditionalFormatSpec.prototype.setRangeOperator = function (ruleIdx, type) {
    var rule = this.getRule(ruleIdx);
    var endCondition;

    if (rule) {
      endCondition = rule.setRangeOperator(type);

      if (endCondition) {
        this._setDefaultRuleConditionValues(rule);
      }
    }

    return endCondition;
  };

  ConditionalFormatSpec.prototype.isValidRuleIndex = function (ruleIndex) {
    return ruleIndex >= 0 && ruleIndex <= this.rules.length - 1;
  };

  ConditionalFormatSpec.prototype.setMinMaxValues = function (min, max) {
    this._minValue = min;
    this._maxValue = max;

    this._resetDefaultRuleConditionValues();
  };

  ConditionalFormatSpec.prototype.resetMinMaxValues = function () {
    this._minValue = undefined;
    this._maxValue = undefined;

    this._resetDefaultRuleConditionValues();
  };

  ConditionalFormatSpec.prototype.hasMinMaxValues = function () {
    return this._minValue !== undefined && this._maxValue !== undefined;
  };

  ConditionalFormatSpec.prototype.getMaxValue = function () {
    return this._maxValue;
  };

  ConditionalFormatSpec.prototype.getMinValue = function () {
    return this._minValue;
  };

  ConditionalFormatSpec.prototype.setActive = function (active) {
    this._active = active;
  };

  ConditionalFormatSpec.prototype.isActive = function () {
    return this._active;
  };

  ConditionalFormatSpec.prototype.setHeatId = function (heatId) {
    this.heatId = heatId;
  };

  ConditionalFormatSpec.prototype.getHeatId = function () {
    return this.heatId;
  };

  ConditionalFormatSpec.prototype.updateVisType = function (visType) {
    if (this._visType !== visType) {
      this._visType = visType;
      ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.updateBlackListedAttrBaseOnVisType(visType, 'backgroundOpacity', this._blackListedAttr);
      this.rules.forEach(function (rule) {
        rule.updateVisType(visType);
      });
    }
  };

  ConditionalFormatSpec.prototype.toJSON = function (saveToContentModel) {
    var jsonObj = _super.prototype.toJSON.call(this, saveToContentModel);

    if (saveToContentModel) {
      delete jsonObj['colorBy'];
    } else {
      delete jsonObj['heatId'];
    }

    return jsonObj;
  };

  ConditionalFormatSpec.prototype._resetDefaultRuleConditionValues = function () {
    var _this = this;

    this.rules.forEach(function (rule) {
      _this._setDefaultRuleConditionValues(rule);
    });
  };

  ConditionalFormatSpec.prototype._setDefaultRuleConditionValues = function (rule) {
    if (rule.getStartCondition()) {
      rule.getStartCondition().setDefaultValue(this.scale, this._minValue, this._maxValue);
    }

    if (rule.getEndCondition()) {
      rule.getEndCondition().setDefaultValue(this.scale, this._minValue, this._maxValue);
    }
  };

  ConditionalFormatSpec._ignoreAttr = ['_visType', '_minValue', '_maxValue'];
  return ConditionalFormatSpec;
}(BaseProperty_1.default);

exports.ConditionalFormatSpec = ConditionalFormatSpec;

var ConditionalFormattingSpec =
/** @class */
function (_super) {
  __extends(ConditionalFormattingSpec, _super);

  function ConditionalFormattingSpec(spec, visType) {
    var _a;

    var _this = _super.call(this) || this;

    (_a = _this._blackListedAttr).push.apply(_a, ['_defaultFormatAsString', '_visType']);

    _this._visType = visType;
    _this.conditionalFormats = new Array();

    if (ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.isKpiVis(visType)) {
      _this._blackListedAttr.push('summaryFillColor');
    }

    _this._createKpiPlaceHolderSpec(); // The spec was retrieved on Content Model so restore it


    if (spec) {
      var conditionalFormats = spec.conditionalFormats;
      _this.summaryFillColor = spec.summaryFillColor;
      conditionalFormats.forEach(function (format) {
        var condFormatToAdd = ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.createConditionalFormatSpec(format, _this._visType);

        _this.conditionalFormats.push(condFormatToAdd);

        var defaultFormat = ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.getDefaultFormat(format.dataItemId, _this._visType);

        _this._setDefaultFormatString(defaultFormat);
      });
    }

    return _this;
  }

  ConditionalFormattingSpec.prototype.hasConditionalFormat = function (dataItemId) {
    return !!(dataItemId && this.conditionalFormats.find(function (condFormat) {
      return condFormat.getDataItemId() === dataItemId;
    }));
  };

  ConditionalFormattingSpec.prototype.hasDefaultOnlyConditionalFormat = function () {
    return this.conditionalFormats.length === 1 && this.conditionalFormats[0].getDataItemId() === ConditionalFormatSpecHelper_1.DEFAULT_FORMAT;
  };

  ConditionalFormattingSpec.prototype.getConditionalFormats = function () {
    return this.conditionalFormats.filter(function (condFormat) {
      return condFormat.getDataItemId() !== MeasureDataItem_1.default.getPlaceHolderMeaureColumnId();
    });
  };

  ConditionalFormattingSpec.prototype.getConditionalFormatById = function (dataItemId, bCreate) {
    if (bCreate === void 0) {
      bCreate = false;
    }

    var condFormat = this.conditionalFormats.find(function (conditionalFormat) {
      return conditionalFormat.getDataItemId() === dataItemId;
    });

    if (!condFormat && bCreate) {
      condFormat = ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.getDefaultFormat(dataItemId, this._visType);
      this.conditionalFormats.push(condFormat);
    }

    if (!condFormat) {
      throw new Error("Conditional Format not found for " + dataItemId + " during getConditionalFormatById call");
    }

    this._setDefaultFormatString(condFormat);

    return condFormat;
  };

  ConditionalFormattingSpec.prototype.removeConditionalFormatById = function (dataItemId) {
    if (!dataItemId) {
      return null;
    }

    var idx = this.conditionalFormats.findIndex(function (conditionalFormat) {
      return conditionalFormat.getDataItemId() === dataItemId;
    });

    if (idx !== -1) {
      this.conditionalFormats.splice(idx, 1);
    }
  };

  ConditionalFormattingSpec.prototype.setSummaryFillColor = function (hexColor) {
    this.summaryFillColor = hexColor && hexColor.toUpperCase();
  };

  ConditionalFormattingSpec.prototype.getSummaryFillColor = function () {
    return this.summaryFillColor;
  };

  ConditionalFormattingSpec.prototype.updateVisType = function (visType) {
    if (this._visType !== visType) {
      this._visType = visType;
      delete this._defaultFormatAsString;
      ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.updateBlackListedAttrBaseOnVisType(visType, 'summaryFillColor', this._blackListedAttr);
      this.conditionalFormats.forEach(function (condFormat) {
        condFormat.updateVisType(visType);
      });
    }
  };

  ConditionalFormattingSpec.prototype.getContentModelJsonSpec = function () {
    var json = _super.prototype.getContentModelJsonSpec.call(this);

    this._purgeDefaultFormats(json.conditionalFormats);

    var hasContent = json.conditionalFormats.length > 0 || !ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.isKpiVis(this._visType) && json.summaryFillColor;
    return hasContent ? json : undefined;
  };

  ConditionalFormattingSpec.prototype.toJSON = function (saveToContentModel) {
    var spec = _super.prototype.toJSON.call(this, saveToContentModel);

    var conditionalFormats = spec['conditionalFormats'];

    if (conditionalFormats) {
      spec['conditionalFormats'] = conditionalFormats.filter(function (condFormat) {
        return condFormat['dataItemId'] !== MeasureDataItem_1.default.getPlaceHolderMeaureColumnId();
      });
    }

    return spec;
  };

  ConditionalFormattingSpec.prototype._setDefaultFormatString = function (condFormat) {
    if (condFormat && !this._defaultFormatAsString) {
      var jsonObj = condFormat.getContentModelJsonSpec(); // Since dataItemId is a unique value per condFormat that is not shared as a default format so delete it

      delete jsonObj['dataItemId'];
      this._defaultFormatAsString = JSON.stringify(jsonObj);
    }
  };
  /**
   * If undo/redo action results in a conditional format that is the default format then purge it from the conditionalFormats array to prevent it from being
   * stored in the content model
  */


  ConditionalFormattingSpec.prototype._purgeDefaultFormats = function (conditionalFormats) {
    var _this = this;

    if (conditionalFormats === void 0) {
      conditionalFormats = [];
    }

    var validFormats = [];
    conditionalFormats.forEach(function (format) {
      var clonedSpec = JSON.parse(JSON.stringify(format));

      if (clonedSpec['_active']) {
        // Strip out dataItemId before compare with default
        delete clonedSpec['dataItemId'];

        if (clonedSpec['heatId'] && clonedSpec['heatId'] === 'defaultHeatId') {
          delete clonedSpec['heatId'];
        }

        if (JSON.stringify(clonedSpec) !== _this._defaultFormatAsString) {
          delete clonedSpec['_active']; // Now put back dataItemId so that they can be save to content model

          clonedSpec['dataItemId'] = format.dataItemId;
          validFormats.push(clonedSpec);
        }
      }
    });
    conditionalFormats.length = 0;
    conditionalFormats.push.apply(conditionalFormats, validFormats);
  };

  ConditionalFormattingSpec.prototype._createKpiPlaceHolderSpec = function () {
    var condFormat = this.conditionalFormats.find(function (conditionalFormat) {
      return conditionalFormat.getDataItemId() === MeasureDataItem_1.default.getPlaceHolderMeaureColumnId();
    });

    if (!condFormat) {
      condFormat = ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.getDefaultFormat(MeasureDataItem_1.default.getPlaceHolderMeaureColumnId(), this._visType);
      this.conditionalFormats.push(condFormat);
    }
  };

  return ConditionalFormattingSpec;
}(BaseProperty_1.default);

exports.ConditionalFormattingSpec = ConditionalFormattingSpec;
